import React, { useState, useEffect, useContext, useCallback } from 'react'
import { Link, Redirect } from 'react-router-dom'

// images
import logo from '~/assets/logo/jgwebcom_n.svg'
import leftArrow from '~/assets/icons/left-arrow.svg'

// Context
import { AuthContext } from '~/hooks/auth'

//style 
import { MainContainer, Content, Logo, BackButton } from './style'
import {
  modalStyles, ModalOverlay,
  ModalContainer,
  ButtonActive,
  ButtonNormal
} from './style'

// main style
import { color } from '~/styles/variables'

//conf
import { BASE_URL_SITE } from '~/services/conf'
import { getCookie } from '~/services/functions'

// components
import FormLogin from './Form'

const Login = () => {
  const auth = useContext(AuthContext)

  const [loginData, setLoginData] = useState({
    email: '',
    senha: '',
    recurso_acessibilidade: localStorage.getItem('user_accessibility') || '99'
  })

  const [showAcessibilityModal, setShowAcessibilityModal] = useState(false)

  const accessibilityOptions = {
    modules: {
      increaseTextSpacing: false,
      decreaseTextSpacing: false,
      increaseLineHeight: false,
      decreaseLineHeight: false
    },
    textToSpeechLang: 'pt-BR',
    speechToTextLang: 'pt-BR',
    labels: {
      resetTitle: 'Resetar configurações',
      closeTitle: 'Fechar menu',
      menuTitle: 'Menu de Acessibilidade',
      increaseText: 'Aumentar tamanho do texto',
      decreaseText: 'Diminuir tamanho do texto',
      increaseTextSpacing: 'Aumentar espaçamento do texto',
      decreaseTextSpacing: 'Diminuir espaçamento do texto',
      increaseLineHeight: 'Aumentar altura da linha',
      decreaseLineHeight: 'Diminuir altura da linha',
      invertColors: 'Inverter cores',
      grayHues: 'Tons de cinza',
      underlineLinks: 'Sublinhar links',
      bigCursor: 'Cursor grande',
      readingGuide: 'Guia de leitura',
      textToSpeech: 'Leitura de voz (Texto para Fala)',
      speechToText: 'Comando de voz (Fala para Texto)',
      disableAnimations: 'Desativar animações',
      hotkeyPrefix: 'Atalho:',
    }
  };

  const initAccessibility = useCallback((value) => {
    const recurso = String(value);
    localStorage.setItem('user_accessibility', recurso);

    if (recurso === "1") {
      if (!document.getElementById('plugin-blind-script')) {
        const script = document.createElement('script');
        script.id = 'plugin-blind-script';
        script.src = "/plugin_blind_accessibility.js";
        script.async = true;
        document.head.appendChild(script);
      }
    } else if (recurso === "2") {
      if (window.widgetJaIniciado) return;
      window.widgetJaIniciado = true;

      const optionsComPersistencia = {
        ...accessibilityOptions,
        session: {
          persistent: true
        }
      };

      if (window.Accessibility) {
        new window.Accessibility(optionsComPersistencia);
      } else {
        const script = document.createElement('script');
        script.src = "https://cdn.jsdelivr.net/npm/accessibility@1.2.0/dist/main.bundle.js";
        script.async = true;
        script.onload = () => {
          new window.Accessibility(optionsComPersistencia);
        };
        document.head.appendChild(script);
      }
    }
  }, []); 

  useEffect(() => {
    const tokenCookie = getCookie('@jgwebcom:token');
    const hasChecked = localStorage.getItem('accessibility_onboarding_done');
    const prefExistente = localStorage.getItem('user_accessibility');

    if (tokenCookie) {

      if (prefExistente && prefExistente !== '99' && !hasChecked) {
        localStorage.setItem('accessibility_onboarding_done', 'true');
        return; 
      }

      if (!hasChecked) {
        setShowAcessibilityModal(true);
      }
    }

    const prefGravada = loginData.recurso_acessibilidade;
    if (prefGravada === "1" || prefGravada === "2") {
      initAccessibility(prefGravada);
    }
  }, [auth.signIn.signInState.loading]);

  useEffect(() => {
    const pref = String(loginData.recurso_acessibilidade);
    localStorage.setItem('user_accessibility', pref);

    if (pref === "1" || pref === "2") {
      initAccessibility(pref);
    }
  }, [loginData.recurso_acessibilidade]);

  const handleFormFill = field => evt => {
    setLoginData({
      ...loginData,
      [field]: evt.target.value
    })
  }

  const handleAccessibilityChoice = (value) => {
    setLoginData(prev => ({ ...prev, recurso_acessibilidade: value }));
    localStorage.setItem('user_accessibility', String(value));

    localStorage.setItem('accessibility_onboarding_done', 'true');
    setShowAcessibilityModal(false);

    initAccessibility(value);

    setShowAcessibilityModal(false);

    window.location.href = '/';
  }

  const [attempt, setAttempt] = useState(0);

  const handleLogin = () => {
    setAttempt(a => a + 1);
    auth.signIn.signInUser(loginData)
  }

  useEffect(() => {
    const { error } = auth.signIn.signInState;
    if (error && (error === "Senha incorreta" || error === "Usuário não encontrado")) {
      setLoginData(prev => ({ ...prev, senha: '' }));
    }
  }, [auth.signIn.signInState.error, attempt]);


  const hasChecked = localStorage.getItem('accessibility_onboarding_done');
  const tokenCookie = getCookie('@jgwebcom:token')
  if (tokenCookie && hasChecked === 'true') {
    return <Redirect to='/' />
  }

  return (
    <MainContainer>
      {showAcessibilityModal && (
        <ModalOverlay>
          <ModalContainer>
            <h2>Preferências de Acessibilidade</h2>
            <p>Como você prefere navegar?</p>

            <div style={{ display: 'flex', gap: '15px', flexDirection: 'column' }}>

              <ButtonActive
                onClick={() => handleAccessibilityChoice('1')}
                style={{ backgroundColor: '#99ba3f' }} 
              >
                 Ativar Leitura em Voz Alta
              </ButtonActive>

                <ButtonActive onClick={() => handleAccessibilityChoice('2')}>
                  Ativar Assistência Visual (Baixa Visão)
                </ButtonActive>

                <ButtonNormal onClick={() => handleAccessibilityChoice('99')}>
                  Navegação Padrão
                </ButtonNormal>
            </div>

            <p style={{ marginTop: '20px', fontSize: '12px', color: '#888' }}>
              Você poderá alterar isso a qualquer momento nas configurações do perfil.
            </p>
          </ModalContainer>
        </ModalOverlay>
      )}

      <Content bg={color.fourth}>
        <BackButton href={`${BASE_URL_SITE}`} title="Ir para o site">
          <img src={leftArrow} alt="Seta para trás" />
          Ir para o site
        </BackButton>
        <Logo src={logo} alt="Jgwebcom" />
      </Content>
      <Content>
        <FormLogin
          handleFormFill={handleFormFill}
          handleLogin={handleLogin}
          formData={loginData}
          sending={auth.signIn.signInState.loading}
          resMsg={auth.signIn.signInState.error} />
        <Link to="/politica-de-privacidade">Políticas de privacidade</Link>
      </Content>
    </MainContainer>
  )
}

export default Login